import React, { forwardRef } from 'react';
import type { ButtonV2Props } from '@withjoy/joykit';
import { ButtonV2, styled } from '@withjoy/joykit';
import { useUnlockDialogButtonStyles, useUnlockDialogColor } from '../useUnlockDialogButtonStyles';

// `&&` doubles the class specificity and `!important` overrides JoyKit's outline-variant
// `&[disabled]` rules — without this, the loading button renders a grey border and a grey
// (currentColor-inheriting) spinner instead of the page font color.
const StyledButton = styled(ButtonV2)<{ $color: string }>`
  &&[disabled],
  &&[aria-disabled='true'] {
    color: ${p => p.$color} !important;
    border-color: ${p => p.$color} !important;
    background-color: transparent !important;
  }
`;

export const UnlockSubmitButton = forwardRef<HTMLButtonElement, ButtonV2Props>((props, ref) => {
  const color = useUnlockDialogColor();
  const buttonStyles = useUnlockDialogButtonStyles();
  return (
    <StyledButton
      ref={ref}
      $color={color}
      {...buttonStyles}
      {...props}
    />
  );
});
UnlockSubmitButton.displayName = 'UnlockSubmitButton';
